import { render, staticRenderFns } from "./DealershipApplicationCommentCard.vue?vue&type=template&id=21be98be&scoped=true"
import script from "./DealershipApplicationCommentCard.vue?vue&type=script&lang=js"
export * from "./DealershipApplicationCommentCard.vue?vue&type=script&lang=js"
import style0 from "./DealershipApplicationCommentCard.vue?vue&type=style&index=0&id=21be98be&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21be98be",
  null
  
)

export default component.exports